import {
  GeneralMediumAdd,
  GeneralMediumAddCircle,
  GeneralMediumBank,
  GeneralMediumCall,
  GeneralMediumCar,
  GeneralMediumChat,
  GeneralMediumCheck2,
  GeneralMediumClose,
  GeneralMediumContract,
  GeneralMediumDesktop,
  GeneralMediumDiscord,
  GeneralMediumDownload,
  GeneralMediumEdit,
  GeneralMediumEmail,
  GeneralMediumEuro,
  GeneralMediumFacebook,
  GeneralMediumHappy,
  GeneralMediumHome,
  GeneralMediumInstagram,
  GeneralMediumLicensePlate,
  GeneralMediumLightBulb,
  GeneralMediumLinkedin,
  GeneralMediumMobile,
  GeneralMediumNavigation,
  GeneralMediumNotification,
  GeneralMediumPayments,
  GeneralMediumProfile,
  GeneralMediumQuestion,
  GeneralMediumQuestionCircle,
  GeneralMediumSad,
  GeneralMediumSearch,
  GeneralMediumStars,
  GeneralMediumTelepassStore,
  GeneralMediumTime,
  GeneralMediumTwitter,
  GeneralMediumUsers,
  GeneralMediumYoutube,
  GeneralSmallCheckTick,
  InsuranceMediumAllInsurances,
  InsuranceMediumCarCollision,
  InsuranceMediumCarInsurance,
  InsuranceMediumInsuranceSki,
  InsuranceMediumInsuranceTravel,
  InsuranceMediumMobilitaProtetta,
  InsuranceMediumMobilityInsurance,
  InsuranceMediumRoadAssistance,
  InsuranceMediumTollingRimborso,
  ServicesMediumAllServices,
  ServicesMediumAreaC,
  ServicesMediumBikeSharing,
  ServicesMediumBollo,
  ServicesMediumBus,
  ServicesMediumCarCharging,
  ServicesMediumCarReview,
  ServicesMediumCarSharing,
  ServicesMediumCashback,
  ServicesMediumFerry,
  ServicesMediumFlight,
  ServicesMediumFood,
  ServicesMediumFuel,
  ServicesMediumIndoorParking,
  ServicesMediumKickScooterSharing,
  ServicesMediumMemo,
  ServicesMediumMobilitySharing,
  ServicesMediumPagopa,
  ServicesMediumPublicTransport,
  ServicesMediumScooterSharing,
  ServicesMediumSkipass,
  ServicesMediumStrisceBlu,
  ServicesMediumTaxi,
  ServicesMediumTolling,
  ServicesMediumTreni,
  ServicesMediumVeneziaPass,
  ServicesMediumWashout,
} from "@wise-emotions/react-icons";

const ICON_TEXT_NAME_VALUES_V0 = {
  check: GeneralMediumCheck2, // @TODO LORIS
};

const ICONS_GENERAL = {
  general_medium_add: GeneralMediumAdd,
  general_medium_bank: GeneralMediumBank,
  general_medium_call: GeneralMediumCall,
  general_medium_car: GeneralMediumCar,
  general_medium_chat: GeneralMediumChat,
  general_medium_check_2: GeneralSmallCheckTick,
  general_medium_close: GeneralMediumClose,
  general_medium_add_circle: GeneralMediumAddCircle,
  general_medium_contract: GeneralMediumContract,
  general_medium_desktop: GeneralMediumDesktop,
  general_medium_discord: GeneralMediumDiscord,
  general_medium_download: GeneralMediumDownload,
  general_medium_question_circle: GeneralMediumQuestionCircle,
  general_medium_edit: GeneralMediumEdit,
  general_medium_email: GeneralMediumEmail,
  general_medium_euro: GeneralMediumEuro,
  general_medium_happy: GeneralMediumHappy,
  general_medium_home: GeneralMediumHome,
  general_medium_license_plate: GeneralMediumLicensePlate,
  general_medium_light_bulb: GeneralMediumLightBulb,
  general_medium_mobile: GeneralMediumMobile,
  general_medium_notification: GeneralMediumNotification,
  general_medium_navigation: GeneralMediumNavigation,
  general_medium_search: GeneralMediumSearch,
  general_medium_telepass_store: GeneralMediumTelepassStore,
  general_medium_time: GeneralMediumTime,
  general_medium_users: GeneralMediumUsers,
  general_medium_profile: GeneralMediumProfile,
  general_medium_payments: GeneralMediumPayments,
  general_medium_question: GeneralMediumQuestion,
  general_medium_stars: GeneralMediumStars,
  general_medium_sad: GeneralMediumSad,
  general_medium_facebook: GeneralMediumFacebook,
  general_medium_twitter: GeneralMediumTwitter,
  general_medium_instagram: GeneralMediumInstagram,
  general_medium_linkedin: GeneralMediumLinkedin,
  general_medium_youtube: GeneralMediumYoutube,
};

const ICONS_SERVICE = {
  services_medium_car_sharing: ServicesMediumCarSharing,
  services_medium_car_review: ServicesMediumCarReview,
  services_medium_cashback: ServicesMediumCashback,
  services_medium_bike_sharing: ServicesMediumBikeSharing,
  services_medium_scooter_sharing: ServicesMediumScooterSharing,
  services_medium_kick_scooter_sharing: ServicesMediumKickScooterSharing,
  services_medium_taxi: ServicesMediumTaxi,
  services_medium_treni: ServicesMediumTreni,
  services_medium_ferry: ServicesMediumFerry,
  services_medium_flight: ServicesMediumFlight,
  services_medium_fuel: ServicesMediumFuel,
  services_medium_strisce_blu: ServicesMediumStrisceBlu,
  services_medium_car_charging: ServicesMediumCarCharging,
  services_medium_memo: ServicesMediumMemo,
  services_medium_tolling: ServicesMediumTolling,
  services_medium_venezia_pass: ServicesMediumVeneziaPass,
  services_medium_all_services: ServicesMediumAllServices,
  services_medium_area_c: ServicesMediumAreaC,
  services_medium_indoor: ServicesMediumIndoorParking,
  services_medium_mobility_sharing: ServicesMediumMobilitySharing,
  services_medium_bollo: ServicesMediumBollo,
  services_medium_washout: ServicesMediumWashout,
  services_medium_public_transport: ServicesMediumPublicTransport,
  services_medium_bus: ServicesMediumBus,
  services_medium_skipass: ServicesMediumSkipass,
  services_medium_food: ServicesMediumFood,
  services_medium_pagopa: ServicesMediumPagopa,
};

const ICONS_INSURANCE = {
  insurance_medium_car_collision: InsuranceMediumCarCollision,
  insurance_medium_all_insurances: InsuranceMediumAllInsurances,
  insurance_medium_car_insurance: InsuranceMediumCarInsurance,
  insurance_medium_tolling_rimborso: InsuranceMediumTollingRimborso,
  insurance_medium_road_assistance: InsuranceMediumRoadAssistance,
  insurance_medium_insurance_travel: InsuranceMediumInsuranceTravel,
  insurance_medium_insurance_ski: InsuranceMediumInsuranceSki,
  insurance_medium_mobility_insurance: InsuranceMediumMobilityInsurance,
  insurance_medium_mobilita_protetta: InsuranceMediumMobilitaProtetta,
};

export const icons = {
  ...ICON_TEXT_NAME_VALUES_V0,
  ...ICONS_GENERAL,
  ...ICONS_SERVICE,
  ...ICONS_INSURANCE,
} as const;
